import { HTTPClient } from "./Client";

const SuporteApi = {

    async salvarSuporteAsync(descricao, tipoSuporte) {
        const novoSuporte = {
            Descricao: descricao,
            TipoSuporte: Number(tipoSuporte),
        };

        await HTTPClient.post(`/Suporte/SalvarSuporte`, novoSuporte);
    },

    async obterSuportePorIdAsync(suporteId) {

        const response = await HTTPClient.get(`/Suporte/ObterSuportePorId/${suporteId}`);
        return response.data;
    },

    async listarTiposSuporteAsync() {
        const response = await HTTPClient.get(`/Suporte/ListarTiposSuporte`);
        return response.data;
    },


    async listarSuportesComPaginacaoAsync(pagina, tipoSuporte, respondido, descricao) {
        const suportesComPaginacao = {
            Pagina: pagina,
            TipoSuporte: Number(tipoSuporte),
            Respondido: respondido,
            Descricao: descricao
        };

        const response = await HTTPClient.post(`/Suporte/ListarSuportesComPaginacao`, suportesComPaginacao);
        return response.data;
    },

    async deletarSuporteAsync(suporteId) {

        const response = await HTTPClient.put(`/Suporte/DeletarSuporte/${suporteId}`);
        return response.data;
    },
}

export default SuporteApi;